import { useCallback } from "react";

const useLastViewedPhoto = () => {
  const setPhotoToScrollTo = useCallback((photoId: string | null) => {
    if (!photoId || typeof window === "undefined") return;

    window.localStorage.setItem("photoToScrollTo", photoId);
  }, []);

  const photoIdToScrollTo = typeof window === "undefined" ? null : window.localStorage.getItem("photoToScrollTo");

  return [photoIdToScrollTo, setPhotoToScrollTo] as const;
};

export default useLastViewedPhoto;
